export const urlImages = [
    'assets/projects/weather_app.webp',
    'assets/projects/etsy.png',
    'assets/projects/gourmet_hound.webp',
    'assets/projects/kanba_app.png',
    'assets/projects/propfolio.jpg',
    'assets/projects/cli.png',
    'assets/projects/bookstorage_app.png',
    'assets/projects/owner.png',
]